import {
    // getCurUserInfo
} from '@/api/system/user'

const getters = {
    // xx: (state, getters, rootState, rootGetters) => {}
    userInfo: state => {
        let req = {}
        if (state.token) {
            if (state.userInfo) {
                req = state.userInfo
            } else {
                // getCurUserInfo()
                //     .then(userInfo => {
                //         req = userInfo
                //     })
                //     .catch(() => {
                //     })
                state.userInfo = req
            }
        }
        return req
    },
    isAdmin: (state, {
        userInfo = {}
    }) => {
        const {
            roles = []
        } = userInfo
        return roles.contains(1)
    },
    isTeacher: (state, {userInfo = {}}) => {
        const {roles = []} = userInfo
        return roles.contains(3)
    },
    isLogin: (state) => {
        return state.token != null && state.token !== '';
    },
    isStudent: (state, {userInfo = {}}) => {
        const {roles = []} = userInfo
        return roles.contains(2)
    },
    isDeptAdmin: (state, {
        userInfo = {}
    }) => {
        const {
            roles = []
        } = userInfo
        return roles.contains(8)
    },
    mySoftwareModeList({loginUserDept}) {
        // 根据用户部门限制实验方式
        let allList = [
            {value: 0, label: '远程实验', disabled: true},
            {value: 1, label: '本地实验', disabled: true},
            {value: 2, label: '远程/本地', disabled: true},
        ]
        let {deptId, softwareMode} = loginUserDept
        if (deptId == null || deptId === "") {
            return allList
        } else if (deptId <= 0) {
            return allList.map(item => {
                item.disabled = false
                return item
            })
        } else if (softwareMode == null || softwareMode === "") {
            return allList
        }

        let modeArr = softwareMode.split(",")
        if (modeArr.some(item => item === "2")) {
            allList
                .filter(item => item.value === 0)
                .map(item => {
                    item.disabled = false
                    return item
                })
        }
        if (modeArr.some(item => item === "1")) {
            allList
                .filter(item => item.value === 1)
                .map(item => {
                    item.disabled = false
                    return item
                })
        }
        if (modeArr.some(item => item === "1") && modeArr.some(item => item === "2")) {
            allList
                .filter(item => item.value === 2)
                .map(item => {
                    item.disabled = false
                    return item
                })
        }
        return allList
    }
}

export default getters
